module.exports = __webpack_public_path__ + "15f15a5a8b45f3a5421c980cb47d543c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/21_PROP_VET_01.png
// module id = 122
// module chunks = 0